import { defineMessages } from 'react-intl';

export default defineMessages({
  P0: {
    id: 'view.files.filter.priority.P0',
    defaultMessage: 'P0',
  },
});
